import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function IconBase({
	children,
	className,
	color,
	size,
	style,
	type,
	...props
}) {
	const svgStyle = Object.assign(
		{ width: size, height: size, fill: color },
		style
	);
	return (
		<svg
			aria-label={type}
			className={cx('c-icon', `x-${type}`, className)}
			preserveAspectRatio="xMinYMin meet"
			style={svgStyle}
			version="1.1"
			viewBox="0 0 24 24"
			{...props}>
			{children}
		</svg>
	);
}

export const iconPropTypes = {
	className: PropTypes.string,
	color: PropTypes.string,
	size: PropTypes.string,
	style: PropTypes.object
};

IconBase.propTypes = {
	...iconPropTypes,
	children: PropTypes.node.isRequired,
	type: PropTypes.string.isRequired
};
